// extracted by mini-css-extract-plugin
export default {"icon":"Search-index__icon--arg3I"};